/** Central notices (/notices) — mirrors api/src/functions/notices/shared/notice-store.ts. */

export type NoticeSeverity = 'info' | 'warning' | 'critical';
export type NoticeStatus = 'scheduled' | 'active' | 'ended' | 'expired';

export interface NoticeRecord {
    id: number;
    severity: NoticeSeverity;
    title: string;
    body: string;
    /** ISO 8601 UTC */
    validFrom: string;
    validUntil: string;
    createdBy: string;
    createdVia: 'page' | 'cli';
    createdAt: string;
    expiredAt: string | null;
    expiredBy: string | null;
    apps: string[];
    /** One route of this app (migration 216), or null for the whole of every target app. */
    page: string | null;
    status: NoticeStatus;
}

export interface NoticeList {
    notices: NoticeRecord[];
    total: number;
    limit: number;
}

export interface NoticeApp {
    appKey: string;
    appName: string;
    sortOrder: number;
}

/** An active page of this app, for the optional page target (`GET /notices/pages`). */
export interface NoticeTargetPage {
    pageUrl: string;
    pageName: string;
}

export interface NewNoticeRequest {
    severity: NoticeSeverity;
    title: string;
    body: string;
    validFrom?: string;
    validUntil?: string;
    minutes?: number;
    apps: string[];
    /** Only with `apps: ['reporting']` — the API refuses it otherwise. */
    page?: string;
}

/** Same widths as the table and the consumer module (§4). */
export const NOTICE_MAX_TITLE = 200;
export const NOTICE_MAX_BODY = 1000;
export const NOTICE_MAX_WINDOW_MINUTES = 30 * 24 * 60;
